//prompts
export const PROMPT_ARCHIVE_ACTION = 'PROMPT_ARCHIVE_ACTION';
export const PROMPT_CONVERT_TEXT_TO_VOICE_ACTION = "PROMPT_CONVERT_TEXT_TO_VOICE_ACTION";
export const PROMPT_AUDIO_BY_PROMPT_ID_ACTION = "PROMPT_AUDIO_BY_PROMPT_ID_ACTION";
export const UPDATE_USED_PROMPT_ACTION ="UPDATE_USED_PROMPT_ACTION";
//new prompts actions
export const PROMPT_LANGUAGE_LIST_LOAD_ACTION = "PROMPT_LANGUAGE_LIST_LOAD_ACTION";
export const PROMPT_LIST_LOAD_ACTION = "PROMPT_LIST_LOAD_ACTION";
export const PROMPT_LOAD_BY_ID_ACTION = "PROMPT_LOAD_BY_ID_ACTION";
export const PROMPT_FILTER_LIST_LOAD_ACTION = "PROMPT_FILTER_LIST_LOAD_ACTION";
export const PROMPT_VOICE_LIST_LOAD_ACTION = "PROMPT_VOICE_LIST_LOAD_ACTION";
export const CREATE_PROMPT_SAVE_ACTION = "CREATE_PROMPT_SAVE_ACTION";
export const UPDATE_PROMPT_SAVE_ACTION = "UPDATE_PROMPT_SAVE_ACTION";
export const PROMPT_DROPDOWNS_API_LOAD_ACTION = "PROMPT_DROPDOWNS_API_LOAD_ACTION";

//voices
export const VOICES_LOAD_ACTION = 'VOICES_LOAD_ACTION';

//partners
export const PARTNER_CREATE_ACTION = "PARTNER_CREATE_ACTION";
export const PARTNER_UPDATE_ACTION = "PARTNER_UPDATE_ACTION";
export const PARTNER_LOAD_BY_ID_ACTION = 'PARTNER_LOAD_BY_ID_ACTION';
export const PARTNER_STATE_LOAD_ACTION = 'PARTNER_STATE_LOAD_ACTION';
export const PARTNERS_LOAD_ACTION = 'PARTNERS_LOAD_ACTION';
export const PARTNER_STATUSES_LOAD_ACTION = 'PARTNER_STATUSES_LOAD_ACTION';
export const PARTNER_ARCHIVE_ACTION = 'PARTNER_ARCHIVE_ACTION';
export const PARTNER_ENTITIES_LOAD_ACTION = 'PARTNER_ENTITIES_LOAD_ACTION';

//campaigns
export const CAMPAIGNS_LOAD_ACTION = "CAMPAIGNS_LOAD_ACTION";
export const CAMPAIGN_BY_ID_ACTION = "CAMPAIGN_BY_ID_ACTION";
export const CAMPAIGN_CREATE_SUBMIT_ACTION = "CAMPAIGN_CREATE_SUBMIT_ACTION"
export const CAMPAIGN_UPDATE_SUBMIT_ACTION = 'CAMPAIGN_UPDATE_SUBMIT_ACTION';
export const CAMPAIGN_STATUSES_LOAD_ACTION = 'CAMPAIGN_STATUSES_LOAD_ACTION';
export const CAMPAIGN_ARCHIVE_ACTION = 'CAMPAIGN_ARCHIVE_ACTION';
export const CAMPAIGN_SOURCETYPES_LOAD_ACTION = 'CAMPAIGN_SOURCETYPES_LOAD_ACTION';
export const CAMPAIGN_LOCALPHONENUMBERS_LOAD_ACTION = 'CAMPAIGN_LOCALPHONENUMBERS_LOAD_ACTION';
export const CAMPAIGN_TOLLFREEPHONENUMBERS_LOAD_ACTION = 'CAMPAIGN_TOLLFREEPHONENUMBERS_LOAD_ACTION';
export const CAMPAIGN_CALLPATHS_LOAD_ACTION = 'CAMPAIGN_CALLPATHS_LOAD_ACTION';
export const CAMPAIGN_CALLPATH_CREATE_ACTION = 'CAMPAIGN_CALLPATH_CREATE_ACTION';
export const CAMPAIGN_CALLPATH_UPDATE_ACTION = 'CAMPAIGN_CALLPATH_UPDATE_ACTION';
export const CAMPAIGN_CLONE_CALLPATHS_LOAD_ACTION = "CAMPAIGN_CLONE_CALLPATHS_LOAD_ACTION";
export const CAMPAIGN_DID_GROUP_CHANGED_ACTION = "CAMPAIGN_DID_GROUP_CHANGED_ACTION";
export const CAMPAIGNS_BY_CALLPATHID_ACTION = "CAMPAIGNS_BY_CALLPATHID_ACTION";
export const CAMPAIGN_CALLTYPES_LOAD_ACTION = "CAMPAIGN_CALLTYPES_LOAD_ACTION";
export const CAMPAIGN_CLEAR_DID_CALCULATION_VALUES_ACTION = "CAMPAIGN_CLEAR_DID_CALCULATION_VALUES_ACTION";
export const UPDATE_CAMPAIGN_CALLATTRIBUTES_STORE_DATA_ACTION = "UPDATE_CAMPAIGN_CALLATTRIBUTES_STORE_DATA_ACTION";
export const CAMPAIGN_GENERTATE_API_KEY_LOAD_ACTION = "CAMPAIGN_GENERTATE_API_KEY_LOAD_ACTION";
export const CAMPAIGN_DYNAMIC_REQUEST_LOAD_ACTION = "CAMPAIGN_DYNAMIC_REQUEST_LOAD_ACTION";
export const CAMPAIGN_AFFILIATETYPES_LOAD_ACTION = "CAMPAIGN_AFFILIATETYPES_LOAD_ACTION";
export const CAMPAIGN_ENTITIES_LOAD_ACTION = 'CAMPAIGN_ENTITIES_LOAD_ACTION';
export const CAMPAIGN_NAME_DIDS_LOAD_ACTION = "CAMPAIGN_NAME_DIDS_LOAD_ACTION";
export const LOAD_ACTIVE_DAY_PART_INTERVAL_ACTION = "LOAD_ACTIVE_DAY_PART_INTERVAL_ACTION";
export const CAMPAIGN_CALL_ATTRIBUTE_CHANNEL_FILTER_LIST_LOAD_ACTION = "CAMPAIGN_CALL_ATTRIBUTE_CHANNEL_FILTER_LIST_LOAD_ACTION";
export const CAMPAIGN_CALL_ATTRIBUTE_CLIENT_FILTER_LIST_LOAD_ACTION = "CAMPAIGN_CALL_ATTRIBUTE_CLIENT_FILTER_LIST_LOAD_ACTION";
export const CAMPAIGN_GET_SUPPRESSED_QUESTION_MAPPINGS_ACTION = "CAMPAIGN_GET_SUPPRESSED_QUESTION_MAPPINGS_ACTION";
export const CAMPAIGN_UPDATE_SUPPRESSED_QUESTION_MAPPINGS_ACTION = "CAMPAIGN_UPDATE_SUPPRESSED_QUESTION_MAPPINGS_ACTION";
export const CAMPAIGN_LOAD_DROPDOWNS_ACTION = "CAMPAIGN_LOAD_DROPDOWNS_ACTION";

//call paths
export const CALLPATHS_LOAD_ACTION = 'CALLPATHS_LOAD_ACTION';
export const CALLPATH_STATUSES_LOAD_ACTION = 'CALLPATH_STATUSES_LOAD_ACTION';
export const CALLPATH_ARCHIVE_ACTION = 'CALLPATH_ARCHIVE_ACTION';
export const CALLPATH_PROMPTCONNECTIONS_LOAD_ACTION = 'CALLPATH_PROMPTCONNECTIONS_LOAD_ACTION';
export const CALLPATH_CREATE_ACTION = 'CALLPATH_CREATE_ACTION';
export const CALLPATH_PROMPTS_LOAD_ACTION = 'CALLPATH_PROMPTS_LOAD_ACTION';
export const CALLPATH_UPDATE_ACTION = "CALLPATH_UPDATE_ACTION";
export const CALLPATH_BY_ID_ACTION = "CALLPATH_BY_ID_ACTION";
export const CALLPATH_DROP_COLUMN_ACTION = "CALLPATH_DROP_COLUMN_ACTION";
export const CALLPATH_REMOVE_PROMPT_ACTION = "CALLPATH_REMOVE_PROMPT_ACTION";
export const CALLPATH_ADD_PROMPT_ACTION = "CALLPATH_ADD_PROMPT_ACTION";
export const CALLPATHS_BY_PROMPTID_ACTION = "CALLPATHS_BY_PROMPTID_ACTION";
export const CALLPATHS_REMOVE_CALLPATH_COLUMN_ACTION = "CALLPATHS_REMOVE_CALLPATH_COLUMN_ACTION";
export const CALLPATH_ENTITIES_LOAD_ACTION = 'CALLPATH_ENTITIES_LOAD_ACTION';

//filters
export const FILTER_CREATE_ACTION = "FILTER_CREATE_ACTION";
export const FILTER_PENALTY_VALUE_UPDATE_ACTION = "FILTER_PENALTY_VALUE_UPDATE_ACTION";
export const FILTER_LOAD_BY_ID_ACTION = "FILTER_LOAD_BY_ID_ACTION";
export const FILTERS_LOAD_ACTION = "FILTERS_LOAD_ACTION";
export const FILTER_TYPE_DROPDOWNS_LOAD_ACTION = "FILTER_TYPE_DROPDOWNS_LOAD_ACTION";

// scheduler epic
export const CALLATTRIBUTE_PAGE_LOAD_ACTION = 'CALLATTRIBUTE_PAGE_LOAD_ACTION';
export const UPDATE_CAMPAIGN_CALLATTRIBUTE_PAGE_ACTION = "UPDATE_CAMPAIGN_CALLATTRIBUTE_PAGE_ACTION";
export const SCHEDULER_ADD_REMOVE_INTERVALS_ACTION = "SCHEDULER_ADD_REMOVE_INTERVALS_ACTION";
export const SCHEDULER_STATUS_CHANGED_ACTION = "SCHEDULER_STATUS_CHANGED_ACTION";
export const SCHEDULER_ADD_DAY_PART_AND_INTERVALS_ACTION = "SCHEDULER_ADD_DAY_PART_AND_INTERVALS_ACTION";
export const SCHEDULER_REMOVE_DAY_PART_AND_INTERVALS_ACTION = "SCHEDULER_REMOVE_DAY_PART_AND_INTERVALS_ACTION";
export const SCHEDULER_USE_INTERVALS_CHANGED_ACTION = "SCHEDULER_USE_INTERVALS_CHANGED_ACTION";
export const SCHEDULER_RESET_INTERVALS_ACTION = "SCHEDULER_RESET_INTERVALS_ACTION";
export const SCHEDULER_INTERVAL_SETTING_CHANGED_ACTION = "SCHEDULER_INTERVAL_SETTING_CHANGED_ACTION";
export const SCHEDULER_DATA_CHANGED_ACTION = "SCHEDULER_DATA_CHANGED_ACTION";
export const SCHEDULER_SET_INTERVAL_SETTING_ACTION = "SCHEDULER_SET_INTERVAL_SETTING_ACTION"
export const SCHEDULET_GET_INTERVAL_ACTION = "SCHEDULET_GET_INTERVAL_ACTION"

//report
export const CALLLOG_LOAD_ACTION = "CALLLOG_LOAD_ACTION";
export const DIDS_LOAD_ACTION ='DIDS_LOAD_ACTION';
export const AFFILIATESUMMARY_LOAD_ACTION = "AFFILIATESUMMARY_LOAD_ACTION";
export const AFFILIATELOG_LOAD_ACTION = "AFFILIATELOG_LOAD_ACTION";
export const CALLLOG_REPORT_PRODUCT_TYPE_ACTION = "CALLLOG_REPORT_PRODUCT_TYPE_ACTION";
export const CALLLOG_REPORT_ACCOUNTS_AND_COMPANIES_ACTION = "CALLLOG_REPORT_ACCOUNTS_AND_COMPANIES_ACTION";
export const CALLLOG_REPORT_DOWNLOAD_CALL_RECORDING_ACTION = "CALLLOG_REPORT_DOWNLOAD_CALL_RECORDING_ACTION";
export const INBOUND_PING_POST_REPORT_LOAD_REPORT_DATA_ACTION = "INBOUND_PING_POST_REPORT_LOAD_REPORT_DATA_ACTION";

// blockedNUmbers

export const BLOCKED_AND_WHITELIST_NUMBERS_ACTION = "BLOCKED_AND_WHITELIST_NUMBERS_ACTION";
export const BLOCKED_OR_WHITELIST_NUMBER_DELETE_ACTION = "BLOCKED_OR_WHITELIST_NUMBER_DELETE_ACTION";
export const BLOCKED_OR_WHITELIST_NUMBER_SAVE_ACTION = "BLOCKED_OR_WHITELIST_NUMBER_SAVE_ACTION";

// support
export const SUPPORT_DETAILS_SAVE_ACTION = "SUPPORT_DETAILS_SAVE_ACTION";

// directMailReportLog
export const DIRECT_MAIL_REPORT_CAMPAIGN_CATEGORIES_ACTION = "DIRECT_MAIL_REPORT_CAMPAIGN_CATEGORIES_ACTION";
export const DIRECT_MAIL_REPORT_SAVE_ACTION = "DIRECT_MAIL_REPORT_SAVE_ACTION";
export const DIRECT_MAIL_REPORT_BY_ID_ACTION = "DIRECT_MAIL_REPORT_BY_ID_ACTION";
export const DIRECTMAIL_LOAD_ACTION = "DIRECTMAIL_LOAD_ACTION";
export const DIRECTMAIL_DELETE_ACTION = "DIRECTMAIL_DELETE_ACTION";

// holidaySchedule
export const HOLIDAY_SCHEDULE_SUMMARY_ACTION = "HOLIDAY_SCHEDULE_SUMMARY_ACTION";
export const HOLIDAY_SCHEDULE_DELETE_ACTION = "HOLIDAY_SCHEDULE_DELETE_ACTION";
export const HOLIDAY_SCHEDULE_SAVE_ACTION = "HOLIDAY_SCHEDULE_SAVE_ACTION";
export const HOLIDAY_SCHEDULE_LOAD_BY_ID_ACTION = "HOLIDAY_SCHEDULE_LOAD_BY_ID_ACTION";

// auditLog
export const AUDIT_LOG_SUMMARY_ACTION = "AUDIT_LOG_SUMMARY_ACTION";

// userRole
export const USER_ROLE_SAVE_ACTION = "USER_ROLE_SAVE_ACTION";
export const USER_ROLE_SUMMARY_ACTION = "USER_ROLE_SUMMARY_ACTION";
export const USER_ROLE_DELETE_ACTION = "USER_ROLE_DELETE_ACTION";
export const USER_ROLE_LOAD_STATUS_ACTION = "USER_ROLE_LOAD_STATUS_ACTION";
export const USER_ROLE_LOAD_USER_ROLES_ACTION = "USER_ROLE_LOAD_USER_ROLES_ACTION";

// campaignSetting
export const CAMPAIGN_SETTING_LOAD_ACTION = "CAMPAIGN_SETTING_LOAD_ACTION";
export const CAMPAIGN_SETTING_UPDATE_ACTION = "CAMPAIGN_SETTING_UPDATE_ACTION";
